import { JobDocumentTypeEnum } from "../job-document.types";
import { PdfTemplateType } from "@/dentlab/src/pdf-templates/document-template.types";

/**
 * Maps a job document type to its default PDF template type for export
 */
export const getDefaultTemplateTypeForDocument = (
	documentType: JobDocumentTypeEnum
): PdfTemplateType | null => {
	switch (documentType) {
		case JobDocumentTypeEnum.Quotation:
			return PdfTemplateType.KOSTENVORANSCHLAG;
		case JobDocumentTypeEnum.DeliveryNote:
			return PdfTemplateType.LIEFERSCHEIN;
		case JobDocumentTypeEnum.CreditNote:
			return PdfTemplateType.GUTSCHRIFT;
		default:
			return null;
	}
};
